export const SET_YEAR = 'SET_YEAR';

export const setYear = (year) => ({
    type: SET_YEAR,
    payload: year,
})